module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "load-mask-parent product-info-component"
  }, [_c('div', {
    class: _vm.loadMask
  }), _vm._v(" "), _c('component-title', {
    attrs: {
      "config": _vm.configTitle
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [(_vm.shop_code) ? _c('span', [_c('b', [_vm._v(_vm._s(_vm.t('Index')))]), _vm._v(": " + _vm._s(_vm.shop_code))]) : _vm._e(), _c('span', [_vm._v("   ")]), _vm._v(" "), (_vm.ean) ? _c('span', [_c('b', [_vm._v(_vm._s(_vm.t('Ean')))]), _vm._v(": " + _vm._s(_vm.ean))]) : _vm._e(), _c('span', [_vm._v("   ")]), _vm._v(" "), (_vm.price) ? _c('span', [_c('b', [_vm._v(_vm._s(_vm.t('Current price')))]), _vm._v(": " + _vm._s(_vm.price))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "product-info-component-components"
  }, [_vm._l((_vm.getComponents), function(component) {
    return [_c(_vm.loadComponent(component.type), {
      tag: "component",
      attrs: {
        "config": component.config,
        "eventBus": _vm.$root,
        "routeParams": _vm.routeParams
      }
    })]
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-064c7efc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProductInfoComponent.vue
// module id = 1225
// module chunks = 2